export default {
  dialogTitle: "修改案件",
  caseName: {
    label: "案件名稱",
    placeholder: "請輸入案件名稱(必填)",
  },
  caseType: {
    label: "案件類型",
    placeholder: "請選擇案件類型",
  },
  caseDescription: {
    label: "案件說明",
    placeholder: "請輸入案件說明",
  },
  buttons: {
    reset: "重置",
    confirm: "確認",
  },
  messages: {
    editSuccess: "修改成功",
  },
  validation: {
    caseNameRequired: "案件名稱為必填項",
    caseNameLength: "長度在 1 到 20個字符",
    caseTypeRequired: "請選擇案件類型",
    caseDescriptionLength: "長度在 1 到 200個字符",
  },
};
